//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'lodash';
import ClickOutside from '@/directives/ClickOutside';
import GridMenu from './GridMenu.vue';

export default {
  name: 'DpGridHeader',
  components: {
    GridMenu,
  },
  directives: {
    ClickOutside,
  },
  props: {
    columns: { type: Array, default: () => [] },
    settings: { type: Object, default: () => {} },
    columnOptions: { type: Object, default: () => ({}) },
    kpi: { type: Object, default: null },
  },
  data() {
    return {
      canResize: false,
      showMenu: false,
      isResizing: false,
      resizingColumn: null,
      dragColumn: null,
    };
  },
  computed: {
    kpiSort() {
      if (!this.columnOptions.$kpi || !this.columnOptions.$kpi.sort) {
        return false;
      }
      return this.columnOptions.$kpi.sort;
    },
    visibleColumns() {
      return this.columns.filter((c) => c.visible);
    },
  },
  methods: {
    getStyle(c) {
      const styleObj = {};
      if (c.width) {
        styleObj.flex = `0 0 ${c.width}px`;
      }
      return styleObj;
    },
    clickHeader(column) {
      this.$emit('sort-change', column);
    },
    exportAsCsv() {
      this.$emit('export-as-csv');
    },
    openMenu() {
      this.showMenu = true;
    },
    closeMenu() {
      this.showMenu = false;
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    toggleColumn(property) {
      this.$emit('toggle-column', property);
    },
    drag(ev, column) {
      this.dragColumn = column;
    },
    drop(ev, column) {
      this.$emit('move-column', { from: this.dragColumn, to: column });
      this.dragColumn = null;
    },
    dragover() {},
    startResize(column) {
      this.canResize = true;
      this.resizingColumn = column;
    },
    endResize(e) {
      if (!this.resizingColumn) {
        return;
      }

      // It looks like binding refs, creates an array rather than an single reference
      const el = this.$refs[`col-${this.resizingColumn.name}`][0];
      const width = e.clientX - el.getBoundingClientRect().left;
      this.$emit('resize-column', { column: this.resizingColumn, width });

      this.canResize = false;
      this.isResizing = false;
      this.resizingColumn = null;
    },
    moveResize: _.debounce(function moveResize(e) {
      if (!this.canResize) {
        return;
      }

      this.isResizing = true;

      const container = this.$el.getBoundingClientRect();
      const left = e.clientX - container.left;

      this.$refs.resizeIndicator.style.left = `${left}px`;
    }, 10),
  },
};
